import {ref} from 'vue';
import * as apiDashboard from '@/api/dashboard';
import {useRoute, useRouter} from "vue-router";


export function useDashboard() {
    const route = useRoute();
    const router = useRouter();
    const loading = ref(false);
    
    const card = ref({});
    const currencies = ref([]);
    const accounts = ref([]);
    
    async function dashboard(currencyCode, filter) {
        loading.value = true;
        try {
            card.value = await apiDashboard.dashboard(currencyCode, filter);
        } catch (e) {
            console.error(e);
        } finally {
            loading.value = false;
        }
    }
    
    async function currencyList() {
        loading.value = true;
        try {
            currencies.value = await apiDashboard.currencies();
        } catch (e) {
            console.error(e);
        } finally {
            loading.value = false;
        }
    }
    
    async function accountList(currencyCode) {
        loading.value = true;
        try {
            accounts.value = await apiDashboard.accounts(currencyCode);
        } catch (e) {
            console.error(e);
        } finally {
            loading.value = false;
        }
    }
    
    return {
        router,
        route,
        currencies,
        accounts,
        card,
        
        dashboard,
        currencyList,
        accountList
    };
}
